{
  "familyId": "STU-LIJN",
  "questions": [
    {
      "id": "STU-LIJN-001",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Een meteoroloog bekijkt een lijndiagram van de temperatuur. Vergelijk de punten en bepaal in welke maand de temperatuur het hoogst was. Klik op het juiste punt.",
      "context": null,
      "options": ["Januari", "April", "Juli", "Oktober"],
      "correctAnswer": 2,
      "data": {
        "data": [
          { "label": "Januari", "value": 3 },
          { "label": "April", "value": 12 },
          { "label": "Juli", "value": 22 },
          { "label": "Oktober", "value": 11 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Lijndiagram lezen", "content": "Zoek het hoogste punt op de lijn. Juli (22°C) is het hoogste punt — dat is de warmste maand.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "line_chart_highest_point",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.84,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel: In een lijndiagram geeft het hoogste punt de grootste waarde aan. Zoek het hoogste punt op de lijn. Lees de waarden af: Januari (3°C), April (12°C), Juli (22°C), Oktober (11°C). Het hoogste punt is Juli met 22°C. Controle-strategie: Kijk of er geen ander punt hoger ligt op de y-as.",
        "solutionSteps": [
          "Lees de waarden af: Jan 3°C, Apr 12°C, Jul 22°C, Okt 11°C",
          "Vergelijk: 22 > 12 > 11 > 3",
          "Juli (22°C) is het hoogste punt"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Januari het warmst is. Maar Januari (3°C) is juist het laagste punt, niet het hoogste. Onthoud: zoek het punt dat het hoogst op de y-as staat.",
          "1": "Je dacht waarschijnlijk dat April het warmst is. Maar April (12°C) is lager dan Juli (22°C). Onthoud: vergelijk alle waarden om het hoogste punt te vinden.",
          "2": "Goed! Juli (22°C) is de warmste maand — het hoogste punt op de lijn.",
          "3": "Je dacht waarschijnlijk dat Oktober het warmst is. Maar Oktober (11°C) is lager dan Juli (22°C). Onthoud: lees de y-as af om de waarden te vergelijken."
        }
      }
    },
    {
      "id": "STU-LIJN-002",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Een parkbeheerder volgt de temperatuur. Tussen welke twee maanden steeg de temperatuur het meest? Klik op de maand waar de stijging eindigde.",
      "context": null,
      "options": ["Maart", "Mei", "Juli", "September"],
      "correctAnswer": 2,
      "data": {
        "data": [
          { "label": "Maart", "value": 8 },
          { "label": "Mei", "value": 16 },
          { "label": "Juli", "value": 24 },
          { "label": "September", "value": 18 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Stijging aflezen", "content": "Bereken het verschil tussen opeenvolgende punten. Maart→Mei: +8, Mei→Juli: +8, Juli→Sept: −6. De grootste stijging eindigt bij Juli.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "line_chart_steepest_rise",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken het verschil tussen opeenvolgende punten. Maart→Mei: 16−8 = +8. Mei→Juli: 24−16 = +8. Juli→Sept: 18−24 = −6 (daling). Beide stijgingen zijn gelijk (+8), maar bij Juli eindigt de laatste stijging — daarna daalt de lijn. Controle-strategie: Reken de stijging voor alle periodes uit om zeker te zijn dat je de grootste hebt.",
        "solutionSteps": [
          "Bereken de verschillen: Maart→Mei = +8, Mei→Juli = +8, Juli→Sept = −6",
          "De stijging stopt bij Juli (daarna daalt de lijn)",
          "Juli is het eindpunt van de stijging"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Maart het eindpunt is. Maar Maart is het beginpunt van de stijging, niet het eindpunt. Onthoud: de vraag vraagt waar de stijging eindigde.",
          "1": "Je dacht waarschijnlijk dat de stijging bij Mei stopt. Maar de lijn stijgt door van Mei naar Juli (+8). Onthoud: volg de lijn tot het punt waar de stijging stopt.",
          "2": "Goed! Bij Juli eindigt de stijging (24°C) — daarna daalt de lijn naar September.",
          "3": "Je dacht waarschijnlijk dat September het eindpunt van de stijging is. Maar September (18°C) is een daling ten opzichte van Juli (24°C). Onthoud: een daling is geen stijging."
        }
      }
    },
    {
      "id": "STU-LIJN-003",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "multiple_choice",
      "question": "Een museummanager bekijkt een lijndiagram van het aantal bezoekers per dag: maandag 120, dinsdag 95, woensdag 140, donderdag 110. Wat is de trend?",
      "context": null,
      "options": ["Wisselend (op en neer)", "Stijgend (alleen omhoog)", "Dalend (alleen omlaag)", "Gelijk (geen verandering)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Trend herkennen", "content": "Kijk of de lijn stijgt, daalt, of op en neer gaat. 120→95 (daling), 95→140 (stijging), 140→110 (daling). De lijn gaat op en neer: wisselend.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "line_chart_trend",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.lijn-trend-alleen-stijgend", "optionIndex": 1, "label": "Denkt dat de lijn alleen stijgt" },
          { "id": "stu.lijn-trend-alleen-dalend", "optionIndex": 2, "label": "Denkt dat de lijn alleen daalt" },
          { "id": "stu.lijn-trend-gelijk-verondersteld", "optionIndex": 3, "label": "Denkt dat de waarden gelijk blijven" }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar de richting van de lijn. 120→95 = daling, 95→140 = stijging, 140→110 = daling. De lijn gaat afwisselend omhoog en omlaag: de trend is wisselend.",
        "solutionSteps": [
          "Bekijk de richting: 120→95 = daling",
          "95→140 = stijging",
          "140→110 = daling",
          "De lijn gaat op en neer → trend is wisselend"
        ],
        "distractorExplanations": {
          "0": "Goed! De lijn gaat op en neer (120→95→140→110), dus de trend is wisselend.",
          "1": "Je dacht waarschijnlijk dat de lijn alleen stijgt. Maar de lijn daalt ook (120→95 en 140→110). Onthoud: bij een stijgende trend gaat de lijn alleen maar omhoog.",
          "2": "Je dacht waarschijnlijk dat de lijn alleen daalt. Maar de lijn stijgt ook (95→140). Onthoud: bij een dalende trend gaat de lijn alleen maar omlaag.",
          "3": "Je dacht waarschijnlijk dat de waarden gelijk zijn. Maar de waarden zijn allemaal verschillend (120, 95, 140, 110). Onthoud: bij een gelijke trend blijven de waarden (bijna) hetzelfde."
        }
      }
    },
    {
      "id": "STU-LIJN-004",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Een ijscoverkoper bekijkt de verkoopcijfers. Vergelijk de punten en bepaal wanneer het aantal verkochte ijsjes het laagst was. Klik op het juiste punt.",
      "context": null,
      "options": ["Week 1", "Week 2", "Week 3", "Week 4"],
      "correctAnswer": 1,
      "data": {
        "data": [
          { "label": "Week 1", "value": 50 },
          { "label": "Week 2", "value": 35 },
          { "label": "Week 3", "value": 80 },
          { "label": "Week 4", "value": 65 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Week",
        "yAxisLabel": "Aantal ijsjes"
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Laagste punt zoeken", "content": "Zoek het laagste punt op de lijn. Week 2 (35) is het laagste punt.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "line_chart_lowest_point",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.83,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel: In een lijndiagram geeft het laagste punt de kleinste waarde aan. Zoek het laagste punt op de lijn. Week 1 (50), Week 2 (35), Week 3 (80), Week 4 (65). Het laagste punt is Week 2 met 35 ijsjes. Controle-strategie: Kijk of er geen ander punt lager ligt op de y-as.",
        "solutionSteps": [
          "Lees de waarden af: Week 1 = 50, Week 2 = 35, Week 3 = 80, Week 4 = 65",
          "Vergelijk: 35 < 50 < 65 < 80",
          "Week 2 (35) is het laagste punt"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Week 1 het laagst is. Maar Week 1 (50) is hoger dan Week 2 (35). Onthoud: zoek het punt dat het laagst op de y-as staat.",
          "1": "Goed! Week 2 (35) is het laagste punt.",
          "2": "Je dacht waarschijnlijk dat Week 3 het laagst is. Maar Week 3 (80) is juist het hoogste punt. Onthoud: lees de vraag goed — 'laagst' betekent het kleinste getal.",
          "3": "Je dacht waarschijnlijk dat Week 4 het laagst is. Maar Week 4 (65) is hoger dan Week 2 (35). Onthoud: vergelijk alle waarden om het laagste punt te vinden."
        }
      }
    },
    {
      "id": "STU-LIJN-005",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "multiple_choice",
      "question": "Een tuinder meet de groei van een plant: week 1 = 2 cm, week 2 = 5 cm, week 3 = 9 cm, week 4 = 14 cm. Hoeveel centimeter groeide de plant tussen week 2 en week 4?",
      "context": null,
      "options": ["9 cm", "5 cm", "12 cm", "14 cm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Verschil berekenen", "content": "Trek de waarde van week 2 af van week 4: 14 − 5 = 9 cm groei.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "line_chart_difference_calc",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.lijn-verschil-beginwaarde-als-groei", "optionIndex": 1, "label": "Beginwaarde gekozen i.p.v. verschil" },
          { "id": "stu.lijn-verschil-verkeerde-range", "optionIndex": 2, "label": "Verschil over verkeerde periode berekend" },
          { "id": "stu.lijn-verschil-eindwaarde-als-groei", "optionIndex": 3, "label": "Eindwaarde gekozen i.p.v. verschil" }
        ]
      },
      "feedback": {
        "explanationText": "Trek de beginwaarde af van de eindwaarde om de groei te berekenen. Week 2 = 5 cm, Week 4 = 14 cm. Groei = 14 − 5 = 9 cm.",
        "solutionSteps": [
          "Lees de waarden af: Week 2 = 5 cm, Week 4 = 14 cm",
          "Bereken het verschil: 14 − 5 = 9 cm",
          "De plant groeide 9 cm tussen week 2 en week 4"
        ],
        "distractorExplanations": {
          "0": "Goed! 14 − 5 = 9 cm groei tussen week 2 en week 4.",
          "1": "Je dacht waarschijnlijk dat 5 cm het antwoord is. Maar 5 cm is de hoogte in week 2, niet de groei. Onthoud: groei = eindwaarde − beginwaarde = 14 − 5 = 9 cm.",
          "2": "Je dacht waarschijnlijk dat je de groei vanaf week 1 moet berekenen. Maar 12 cm is de groei van week 1 tot week 4 (14 − 2 = 12). Onthoud: de vraag gaat over week 2 tot week 4: 14 − 5 = 9 cm.",
          "3": "Je dacht waarschijnlijk dat de totale hoogte het antwoord is. Maar 14 cm is de hoogte in week 4, niet de groei. Onthoud: groei = eindwaarde − beginwaarde."
        }
      }
    },
    {
      "id": "STU-LIJN-006",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "true_false_series",
      "question": "Een biologe houdt de lengte van een zonnebloem bij over 5 weken: W1=10cm, W2=25cm, W3=45cm, W4=60cm, W5=68cm. Welke uitspraken zijn waar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De zonnebloem groeit elke week — de lijn stijgt continu.", "isTrue": true },
          { "text": "Tussen W2 en W3 groeide de plant het hardst (+20 cm).", "isTrue": true },
          { "text": "Tussen W4 en W5 groeide de plant harder dan tussen W3 en W4.", "isTrue": false },
          { "text": "Een steilere lijn betekent een snellere groei.", "isTrue": true },
          { "text": "Lijndiagrammen zijn handig om verandering over tijd te zien.", "isTrue": true }
        ]
      },
      "stimulusAids": [
        {
          "type": "lineChart",
          "data": {
            "data": [
              { "label": "W1", "value": 10 },
              { "label": "W2", "value": 25 },
              { "label": "W3", "value": 45 },
              { "label": "W4", "value": 60 },
              { "label": "W5", "value": 68 }
            ],
            "xAxisLabel": "Week",
            "yAxisLabel": "Lengte (cm)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Lijndiagram interpreteren",
            "content": "Bereken het verschil tussen opeenvolgende punten om de groei per periode te zien. Een steile lijn = snelle verandering, een vlakke lijn = trage verandering.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_statements",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.lijn-steilheid-genegeerd" },
          { "id": "stu.lijn-eindwaarde-zonder-verandering" }
        ]
      },
      "feedback": {
        "explanationText": "Verschillen per week: W1→W2 +15, W2→W3 +20, W3→W4 +15, W4→W5 +8. Lijn stijgt continu (waar), grootste sprong W2→W3 (waar), W4→W5 (+8) is juist kleiner dan W3→W4 (+15). Steiler = sneller (waar). Lijndiagrammen tonen verandering over tijd (waar).",
        "solutionSteps": [
          "Bereken weekverschillen: +15, +20, +15, +8",
          "Lijn stijgt elke week → continu stijgend",
          "Grootste verschil = W2→W3 (+20 cm)",
          "Steilheid van de lijn vertelt over groeisnelheid"
        ]
      }
    },
    {
      "id": "STU-LIJN-007",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "ordering",
      "question": "Zet de stappen voor het analyseren van een trend in een lijndiagram in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Beschrijf de trend (stijgend, dalend of wisselend)",
          "Bekijk de richting tussen opeenvolgende punten",
          "Lees de titel en aslabels van het lijndiagram",
          "Lees de waarden van alle punten af"
        ],
        "correctOrder": [2, 3, 1, 0]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Trend analyseren — stappenplan",
            "content": "1) Titel/assen lezen → 2) Punten aflezen → 3) Richting bekijken tussen punten → 4) Trend benoemen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_trend_steps",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.lijn-trend-zonder-aflezen" }
        ]
      },
      "feedback": {
        "explanationText": "Volgorde: eerst lees je titel en aslabels (waar gaat het over?), dan lees je alle punten af, daarna bekijk je de richting tussen opeenvolgende punten, en pas daarna beschrijf je de trend. Trend benoemen zonder eerst af te lezen leidt tot fouten.",
        "solutionSteps": [
          "Stap 1: Lees titel en aslabels",
          "Stap 2: Lees de waarden van alle punten af",
          "Stap 3: Bekijk richting tussen punten (stijgt/daalt)",
          "Stap 4: Beschrijf de trend in één woord"
        ]
      }
    }
  ]
}